(function($, sd) {
    sd.Tracking = (function() {

        var trackPhoneView = function (dept) {
            if (typeof (dcsMultiTrack) === 'function') {
                dcsMultiTrack('WT.dl', '99', 'WT.z_sid', $('meta[name="WT.z_sid"]').attr('content'), 'WT.z_dname', $('meta[name="WT.z_dname"]').attr('content'), 'WT.z_sdevent', '1', 'WT.z_vphone', '1', 'WT.z_department', dept);
            }
        };

        var trackEnquiryForm = function(dept) {
            if (typeof (dcsMultiTrack) === 'function') {
                dcsMultiTrack('WT.dl', '99', 'WT.z_sid', $('meta[name="WT.z_sid"]').attr('content'), 'WT.z_dname', $('meta[name="WT.z_dname"]').attr('content'), 'WT.z_sdevent', '1', 'WT.z_sdenq', '1', 'WT.z_department', dept);
            }
        };

        var trackEmailMe = function(dept) {
            if (typeof (dcsMultiTrack) === 'function') {
                dcsMultiTrack('WT.dl', '99', 'WT.z_sid', $('meta[name="WT.z_sid"]').attr('content'), 'WT.z_dname', $('meta[name="WT.z_dname"]').attr('content'), 'WT.z_sdevent', '1', 'WT.z_email', '1', 'WT.z_department', dept);
            }
        };

        return {
            trackPhoneView: trackPhoneView,
            trackEnquiryForm: trackEnquiryForm,
            trackEmailMe: trackEmailMe
        };
    })();
})(jQuery, (window.SD || (window.SD = {})));